import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { JsonFileService } from 'src/app/services/json-file/json-file.service';
import { Settore, SettoriService } from 'src/app/services/settori/settori.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DialogCreaCfgSettoriComponent } from './dialog/dialog-crea-cfg-settori/dialog-crea-cfg-settori.component';
import { DialogSottoSettoriComponent } from './dialog/dialog-sotto-settori/dialog-sotto-settori.component';

@Component({
  selector: 'app-cfg-settori',
  templateUrl: './cfg-settori.component.html',
  styleUrls: ['./cfg-settori.component.scss'],
  standalone: false,
})
export class CfgSettoriComponent {
  @ViewChild('tabella') tabella!: ListaTabellareComponent;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public filtri: Filtri[] = [
    {
      titolo: 'Settore',
      forControlName: 'titolo',
      input: 'text',
      riempi: true,
    },
    /* {
      titolo: 'Codice Ateco',
      forControlName: 'codiciAteco',
      input: 'text',
      riempi: true
    }, */
    {
      titolo: 'Codice Ateco',
      forControlName: 'codiciAteco',
      input: 'multiple-option-chip',
      riempi: true,
      larghezza: 3,
      fnDatiOption: (ricerca: string | undefined, ids: any[] | undefined) =>
        this.jsonFileService.getAtecoFiltrato(ricerca, ids).pipe(
          map(
            (ateco: any) =>
              ateco.map((atec: any) => {
                return {
                  id: atec._id,
                  descrizione: atec._id + ' - ' + atec.desc,
                };
              }) || [],
          ),
        ),
      idValueOption: 'id',
      descValueOption: 'descrizione',
      numeroRecOptions: 10,
    },
    {
      forControlName: 'sottoSettori',
      input: 'multiple-option',
      titolo: 'Sotto Settore',
      fnDatiOption: () => this.settoriService.getSottoSettori().pipe(map((value) => value || [])),
      descValueOption: 'titolo',
      idValueOption: 'id',
      riempi: true,
      larghezza: 1,
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    titolo: {
      title: 'Settori',
      value: 'titolo',
      sortable: true,
    },
    modifica: {
      type: 'button',
      buttonIcon: 'edit',
      title: 'Modifica',
      buttonId: 'modifica',
      buttonMostraSempre: true,
      nascondiButton: (record: any) => !this.utenteService.isPermessoAttivo('EDIT_CONFIGURAZIONI'),
    },
    sottoSettori: {
      type: 'button',
      buttonIcon: 'account_tree',
      title: 'Sotto-settori',
      buttonId: 'sottoSettori',
      buttonMostraSempre: true,
    },
    elimina: {
      type: 'button',
      buttonIcon: 'delete',
      title: 'Elimina',
      buttonId: 'elimina',
      nascondiButton: (record: any) =>
        !this.utenteService.isPermessoAttivo('DELETE_CONFIGURAZIONI'),
    },
  };

  constructor(
    private readonly settoriService: SettoriService,
    public dialog: MatDialog,
    private readonly utilityService: UtilityService,
    public readonly utenteService: UtenteService,
    private readonly jsonFileService: JsonFileService,
  ) {}

  creaNuovo(record?: Settore) {
    const dialogCreaSettore = this.dialog.open(DialogCreaCfgSettoriComponent, {
      data: {
        settore: record,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '80%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaSettore.afterClosed().subscribe((result) => {
      this.tabella.caricaDati();
    });
  }

  public mostraSottoSettori(settore: Settore) {
    const dialogCreaSettore = this.dialog.open(DialogSottoSettoriComponent, {
      data: {
        settore,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '95%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaSettore.afterClosed().subscribe((result) => {
      this.tabella.caricaDati();
    });
  }

  public fnCaricamentoDati: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    if (!sortBy) {
      sortBy = [
        {
          chiave: 'titolo',
          sort: 'asc',
        },
      ];
    }

    /*    if (!filters?.find((filt) => filt.chiave === 'codiciAteco')) {
      filters?.push({
        chiave: 'codiciAteco',
        operator: 'ne',
        values: ['SOSGO']
      });
    } */

    return this.settoriService.getSettori(page, pageSize, ricerca, filters, sortBy);
  };

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.creaNuovo(event.data);
        break;
      case 'sottoSettori':
        this.mostraSottoSettori(event.data);
        break;
      case 'elimina':
        this._elimina(event.data.id);
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  private _elimina(id: string) {
    this.utilityService.openDialog({
      descrizione: 'Confermi di eliminare il settore?',
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            this.spinnerOver.show();
            this.settoriService.deleteSettore(id).subscribe({
              next: (result: any) => {
                this.tabella.caricaDati();
                this.spinnerOver.hide();
              },
              error: (err: any) => {
                this.spinnerOver.hide();
                if (err.status === 406) {
                  this.utilityService.openDialog({
                    titolo: 'Attenzione',
                    descrizione: 'Eliminazione non permessa: ' + err.error.message,
                    bottoni: [
                      {
                        nome_btn: 'Chiudi',
                        handler: () => {
                          this.tabella.caricaDati();
                        },
                      },
                    ],
                  });
                } else {
                  this.utilityService.openDialog({
                    titolo: 'Attenzione',
                    descrizione: 'Errore eliminazione: ' + err.error.message,
                    bottoni: [
                      {
                        nome_btn: 'Chiudi',
                        handler: () => {
                          this.tabella.caricaDati();
                        },
                      },
                    ],
                  });
                }
              },
            });
          },
        },
      ],
    });
  }
}
